import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { UpgraderDepositModalComponent } from '@features/upgrader-new/modals/upgrader-deposit-modal/upgrader-deposit-modal.component';

export function provideUpgraderModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'UpgraderDepositModal', component: UpgraderDepositModalComponent, requiresAuth: true }, multi: true },
  ];
}
